import gql from 'graphql-tag';

// QUERIES

export const GET_BOOKLETS_WITH_SERIES = gql`
  query GetBookletsWithSeries($zoneId: ObjectId!) {
    bookletSeriesInZone(zoneId: $zoneId) {
      _id
      name
      logoURL
      logoFullURL
      colorLeft
      colorRight
      colorFont
      colorSalesMaterial
      price
      mainAssociationId
      purchasableThroughAssociations
      totalCommission
      supportCommissionToAssociation
      supportCommissionToMainAssociation
      adminEmails
      defaultValidityMonths
      totalSoldBooklets
      postIds
      postsTitle
      postsButtonLink
      postsButtonLabel
      posts {
        _id
        title
        imageFullURL
        validFrom
        validTo
        validityStatus
      }
      currentBooklet {
        _id
        title
      }
      nextBooklet {
        _id
        title
      }
      booklets {
        _id
        title
        subtitle
        logoURL
        buyableFrom
        buyableTo
        validFrom
        validTo
        colorLeft
        colorRight
        colorFont
        colorSalesMaterial
        price
        usedOrders
        soldBooklets
        adminEmails
        bookletSeriesId
        mainAssociationId
        purchasableThroughAssociations
        totalCommission
        supportCommissionToAssociation
        supportCommissionToMainAssociation
        couponIds
        sponsors { name }
        categorySettings { categoryId }
      }
    }

    bookletsInZone(zoneId: $zoneId) {
      _id
      title
      subtitle
      logoURL
      buyableFrom
      buyableTo
      validFrom
      validTo
      colorLeft
      colorRight
      colorFont
      colorSalesMaterial
      price
      usedOrders
      soldBooklets
      bookletSeriesId
      adminEmails
    }
  }
`;

// MUTATIONS

export const CREATE_BOOKLET_SERIES = gql`
  mutation CreateBookletSeries(
    $name: String!
    $zoneId: ObjectId!
    $adminEmails: [String!]
    $price: Float
    $mainAssociationId: ObjectId
    $purchasableThroughAssociations: [ObjectId!]
    $totalCommission: Float
    $supportCommissionToAssociation: Float
    $supportCommissionToMainAssociation: Float
    $logoURL: String
    $colorLeft: String
    $colorRight: String
    $colorFont: String
    $colorSalesMaterial: String
    $defaultValidityMonths: Int
    $postsTitle: String
    $postsButtonLink: String
    $postsButtonLabel: String
  ) {
    createBookletSeries(
      name: $name
      zoneId: $zoneId
      adminEmails: $adminEmails
      price: $price
      mainAssociationId: $mainAssociationId
      purchasableThroughAssociations: $purchasableThroughAssociations
      totalCommission: $totalCommission
      supportCommissionToAssociation: $supportCommissionToAssociation
      supportCommissionToMainAssociation: $supportCommissionToMainAssociation
      logoURL: $logoURL
      colorLeft: $colorLeft
      colorRight: $colorRight
      colorFont: $colorFont
      colorSalesMaterial: $colorSalesMaterial
      defaultValidityMonths: $defaultValidityMonths
      postsTitle: $postsTitle
      postsButtonLink: $postsButtonLink
      postsButtonLabel: $postsButtonLabel
    ) {
      _id
      name
      logoURL
      logoFullURL
      postsTitle
      postsButtonLink
      postsButtonLabel
      booklets {
        _id
        title
      }
    }
  }
`;

export const UPDATE_BOOKLET_SERIES = gql`
  mutation UpdateBookletSeries(
    $_id: ObjectId!
    $name: String
    $adminEmails: [String!]
    $price: Float
    $mainAssociationId: ObjectId
    $purchasableThroughAssociations: [ObjectId!]
    $totalCommission: Float
    $supportCommissionToAssociation: Float
    $supportCommissionToMainAssociation: Float
    $logoURL: String
    $colorLeft: String
    $colorRight: String
    $colorFont: String
    $colorSalesMaterial: String
    $defaultValidityMonths: Int
    $postsTitle: String
    $postsButtonLink: String
    $postsButtonLabel: String
  ) {
    updateBookletSeries(
      _id: $_id
      name: $name
      adminEmails: $adminEmails
      price: $price
      mainAssociationId: $mainAssociationId
      purchasableThroughAssociations: $purchasableThroughAssociations
      totalCommission: $totalCommission
      supportCommissionToAssociation: $supportCommissionToAssociation
      supportCommissionToMainAssociation: $supportCommissionToMainAssociation
      logoURL: $logoURL
      colorLeft: $colorLeft
      colorRight: $colorRight
      colorFont: $colorFont
      colorSalesMaterial: $colorSalesMaterial
      defaultValidityMonths: $defaultValidityMonths
      postsTitle: $postsTitle
      postsButtonLink: $postsButtonLink
      postsButtonLabel: $postsButtonLabel
    ) {
      _id
      name
      logoURL
      logoFullURL
      defaultValidityMonths
      colorLeft
      colorRight
      colorFont
      colorSalesMaterial
      price
      mainAssociationId
      purchasableThroughAssociations
      totalCommission
      supportCommissionToAssociation
      supportCommissionToMainAssociation
      postsTitle
      postsButtonLink
      postsButtonLabel
    }
  }
`;

export const DELETE_BOOKLET_SERIES = gql`
  mutation DeleteBookletSeries($_id: ObjectId!) {
    deleteBookletSeries(_id: $_id)
  }
`;

// POSTS

export const ADD_POST_TO_SERIES = gql`
  mutation AddPostToSeries($seriesId: ObjectId!, $postId: ObjectId!) {
    addPostToSeries(seriesId: $seriesId, postId: $postId) {
      _id
      postIds
      posts {
        _id
        title
        validityStatus
      }
    }
  }
`;

export const REMOVE_POST_FROM_SERIES = gql`
  mutation RemovePostFromSeries($seriesId: ObjectId!, $postId: ObjectId!) {
    removePostFromSeries(seriesId: $seriesId, postId: $postId) {
      _id
      postIds
    }
  }
`;

export const REORDER_SERIES_POSTS = gql`
  mutation ReorderSeriesPosts($seriesId: ObjectId!, $postIds: [ObjectId!]!) {
    reorderSeriesPosts(seriesId: $seriesId, postIds: $postIds) {
      _id
      postIds
      posts {
        _id
        title
        validityStatus
      }
    }
  }
`;

// Lightweight series → postIds membership, used to filter the zone Inlägg page by series.
export const SERIES_POST_MEMBERSHIP = gql`
  query SeriesPostMembership($zoneId: ObjectId!) {
    bookletSeriesInZone(zoneId: $zoneId) {
      _id
      name
      postIds
    }
  }
`;
